// /** @typedef {InstanceType<typeof import("../nshop-orders.model").NshopOrder>} $NshopOrder */
/** @typedef {import("../nshop-orders.inits").NshopOrder} $NshopOrder */

import { NSHOP_ORDER_PAYMENT_METHODS } from "../nshop-orders.const";

export class NshopOrderAider {
    /**
     * 최소수량 계산
     * @param {$NshopOrder} data
     */
    static calcCountMin(data) {
        return 1;
    }

    /**
     * 최대수량 계산
     * @param {$NshopOrder} data
     */
    static calcCountMax(data) {
        switch (data?.payment?.method) {
            case "card": {
                return 19;
            }

            default: {
                return 40;
            }
        }
    }
    /**
     * 판매가 계산
     * @param {$NshopOrder} data
     */
    static calcPrice(data) {
        let price = { ...data.price };

        price.sum = this.calcPriceSum(data);
        price.fee = this.calcPriceFee(data, price.sum);
        price.sale = this.calcPriceSale(data, price.sum, price.fee);

        return price;
    }

    /**
     * 소계금액 계산
     * @param {$NshopOrder} data
     */
    static calcPriceSum(data) {
        return data.price.unit * data.count;
    }

    /**
     * 수수료 계산
     * @param {$NshopOrder} form
     * @param {number} [sum]
     */
    static calcPriceFee(form, sum) {
        switch (form.payment.method) {
            case "card": {
                if (!sum) sum = this.calcPriceSum(form);
                return sum * 0.035;
            }
            default: {
                return 0;
            }
        }
    }

    /**
     * 판매가 계산
     * @param {$NshopOrder} form
     * @param {number} [sum]
     * @param {number} [fee]
     */
    static calcPriceSale(form, sum, fee) {
        if (!sum) sum = this.calcPriceSum(form);
        if (!fee) fee = this.calcPriceFee(form);
        return sum - fee;
    }

    /**
     * 판매가 계산
     * @param {NshopOrder} data
     */
    static async test(data) {
        let paymentMethodError = !NSHOP_ORDER_PAYMENT_METHODS[data.payment.method]?.uses;
        if (paymentMethodError) throw new Error("결제 수단이 잘못되었습니다");

        let countMax = this.calcCountMax(data);
        if (countMax < data.count) throw new Error("구매 수량이 잘못되었습니다");

        let countMin = this.calcCountMin(data);
        if (data.count < countMin) throw new Error("구매 수량이 잘못되었습니다");

        let price = this.calcPrice(data);

        let priceError = Object.entries(price).some(([key, value]) => data.price[key] !== value);
        if (priceError) throw new Error("구매 금액이 잘못되었습니다");
    }
}
